import React from 'react';
import styled from 'styled-components';

export const SearchSection = ({ searchTicker, setSearchTicker }) => {
  let searchInput;
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      console.log(searchInput);
      setSearchTicker(searchInput.toUpperCase());
    }
  };

  const handleChange = event => {
    searchInput = event.target.value;
  };

  return (
    <SearchBar>
      <SearchTitle>Stock Center</SearchTitle>
      <SearchContainer>
        <SearchDescription>Search by symbol or company</SearchDescription>
        <SearchTextEntry
          type='text'
          onKeyDown={handleKeyPress}
          onChange={handleChange}
        />
      </SearchContainer>
    </SearchBar>
  );
};

const SearchTitle = styled.div`
  color: var(--atom-viz-text-primary);
  font-size: 1.5em;
`;

export const SearchTextEntry = styled.input`
  border: 1px solid #dcdcdc;
  border-radius: 20px;
  color: var(--atom-viz-text-primary);
  padding: 8px;
  text-transform: uppercase;
`;

const SearchBar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 20px 100px;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchDescription = styled.div`
  color: var(--atom-viz-text-primary);
`;
